<template>
  <span>
    <v-btn v-if="defaultBtn" class="teal-color" dark small @click="pickFile">
      {{ !image_path && !uploadedImage ? "Upload Image" : "Change Image" }}
      <v-icon right dark>{{
        !image_path && !uploadedImage ? "mdi-plus-circle" : "mdi-pencil"
      }}</v-icon>
    </v-btn>
    <v-card flat class="d-flex" elevation="2">
      <v-btn
        v-if="uploadedImage != null && defaultBtn == false"
        fab
        absolute
        top
        right
        x-small
        color="error"
        @click="cancel"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-hover v-slot="{ hover }" v-if="defaultBtn == false">
        <v-img :src="getImage()" :aspect-ratio="aspect_ratio" :height="height">
          <v-row
            v-if="hover"
            class="fill-height ma-0 hoverImage"
            align="center"
            @click="pickFile"
            justify="center"
            style="cursor: pointer"
          >
            <div align="center" justify="center" class="white--text">
              <v-icon color="#fff" large>mdi-pencil</v-icon>
              <div class="pa-2 .title">{{ text }}</div>
            </div>
          </v-row>
        </v-img>
      </v-hover>
      <input
        type="file"
        style="display: none"
        ref="image"
        accept="image/*"
        @change="onFilePicked"
      />
      <v-dialog v-model="cropDialog" width="900" @input="cancelCrop">
        <v-card>
          <v-card-title class="headline">Crop</v-card-title>
          <v-card-text class="mt-2" style="min-height: 450px">
            <v-row>
              <v-col md="6">
                <v-card tile flat class="fill-height">
                  <cropper
                    ref="cropper"
                    @change="onChange"
                    :debounce="false"
                    :width="400"
                    :height="400"
                    :src="uploadedImage"
                    :stencil-props="{
                      minAspectRatio: 1,
                      maxAspectRatio: 16 / 9,
                    }"
                  />
                </v-card>
              </v-col>
              <v-col md="6">
                <v-card tile flat width="400" class="fill-height">
                  <preview
                    :width="result.width"
                    :height="result.height"
                    :image="result.image"
                    :coordinates="result.coordinates"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col md="6">
              <div class="d-flex justify-space-around mt-2">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      fab
                      @click="flip(false, true)"
                      ><v-icon>mdi-flip-vertical</v-icon></v-btn
                    >
                  </template>
                  <span> Flip vertical </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      fab
                      @click="flip(true, false)"
                      ><v-icon>mdi-flip-horizontal</v-icon></v-btn
                    >
                  </template>
                  <span> Flip horizontal </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      fab
                      @click="rotate(90)"
                      ><v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                  </template>
                  <span> Rotate Left </span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      fab
                      @click="rotate(-90)"
                      ><v-icon>mdi-rotate-right</v-icon></v-btn
                    >
                  </template>
                  <span> Rotate right </span>
                </v-tooltip>
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-btn class="blue-color" text dark @click="cancelCrop"
              >Cancel</v-btn
            >
            <v-btn class="teal" text dark @click="cropDialog = false">
              <v-icon left>mdi-crop-free</v-icon>Fullsize</v-btn
            >
            <v-btn class="teal" text dark @click="cropImage">
              <v-icon left>mdi-crop</v-icon> Crop</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </span>
</template>

<script>
import { Cropper, Preview } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import images from "@/utils/images";
export default {
  components: {
    Cropper,
    Preview,
  },
  props: {
    image_path: { type: String, default: null },
    aspect_ratio: { type: String, default: "1.7" },
    defaultImage: { type: String, default: "default" },
    height: { type: Number, default: 100 },
    text: { type: String, default: "Click to change the image" },
    defaultBtn: { type: Boolean, default: false },
  },
  data() {
    return {
      uploadedImage: null,
      currentImage: null,
      cropDialog: false,
      result: {
        coordinates: null,
        image: null,
        height: 400,
        width: 400,
      },
      file: null,
    };
  },
  watch: {
    image() {
      this.uploadedImage = null;
    },
    image_path: {
      immediate: true,
      handler() {
        this.uploadedImage = null;
      },
    },
  },
  mounted() {},
  methods: {
    getImage() {
      return this.uploadedImage
        ? this.uploadedImage
        : this.image_path
        ? this.image_path
        : images[this.defaultImage];
    },
    pickFile() {
      this.$refs.image.click();
    },
    cancel() {
      if (this.defaultBtn == false) {
        this.uploadedImage = null;
        this.$emit("remove");
        this.$refs.image.value = null;
      }
    },
    cancelCrop() {
      this.cropDialog = false;
      this.resul = {
        coordinates: null,
        image: null,
      };
      this.cancel();
    },
    onFilePicked(e) {
      let files = e.target.files;
      if (!files.length) {
        return;
      }
      let reader = new FileReader();
      reader.onload = (e) => {
        this.uploadedImage = e.target.result;
        this.file = files[0];
        this.$emit("upload", files[0]);
        this.$emit("result", e.target.result);
        this.$refs.image.value = null;
        this.cropDialog = true;
      };
      reader.readAsDataURL(files[0]);
    },
    cropImage() {
      const { coordinates, canvas } = this.$refs.cropper.getResult();
      this.coordinates = coordinates;
      let imageDataUrl = canvas.toDataURL();
      this.uploadedImage = imageDataUrl;
      this.$emit("upload", this.dataURLtoFile(imageDataUrl, this.file.name));
      this.$emit("result", this.uploadedImage);
      this.$refs.image.value = null;
      this.cropDialog = false;
    },
    onChange({ coordinates, image }) {
      let ratio = coordinates.height / coordinates.width;
      this.result = {
        coordinates,
        image,
      };
      this.result.height = 400 * ratio;
      this.result.width = 400;
    },
    flip(x, y) {
      if (this.$refs.cropper.customImageTransforms.rotate % 180 !== 0) {
        this.$refs.cropper.flip(!x, !y);
      } else {
        this.$refs.cropper.flip(x, y);
      }
    },
    rotate(angle) {
      this.$refs.cropper.rotate(angle);
    },
    dataURLtoFile(dataurl, filename) {
      //Convert base64 to file
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime,
      });
    },
  },
};
</script>

<style></style>
